import { useMemo } from "react";

import { useConnection } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../../context";

export const usePlanRequiredOptionGroupIDs = () => {
	const { viewModel, onSetViewModel, queryData } = useProductDayTripPlanFormModelContext();
	const { availableOptionIDs, requiredOptionGroupIDs } = viewModel;
	const { optionNameAndIDOptions } = queryData.connection;

	const rawAvailableOptionsIDs = availableOptionIDs.value.map((item) => item.value);
	const requiredOptionsNameAndIDOptions = useMemo(
		() => optionNameAndIDOptions.filter((item) => rawAvailableOptionsIDs.includes(item.value)),
		[optionNameAndIDOptions, rawAvailableOptionsIDs],
	);

	const isEdited = useMemo(() => {
		return requiredOptionGroupIDs.isEdited;
	}, [requiredOptionGroupIDs.isEdited]);

	return {
		...useConnection<"requiredOptionGroupIDs">({
			availableItemIDs: requiredOptionGroupIDs,
			nameAndIDOptions: requiredOptionsNameAndIDOptions,
			keyOfValue: "requiredOptionGroupIDs",
			onSetViewModel,
		}),
		isEdited,
	};
};
